import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import HeroSection from '../components/sections/HeroSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import HowItWorks from '../components/sections/HowItWorks';
import WhatYouGet from '../components/sections/WhatYouGet';
import ForYouSection from '../components/sections/ForYouSection';
import WhyDifferent from '../components/sections/WhyDifferent';
import FAQSection from '../components/sections/FAQSection';
import Footer from '../components/sections/Footer';

const LandingPage = () => {
  const [showStickyBtn, setShowStickyBtn] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show sticky button after scrolling past hero (100vh)
      const heroHeight = window.innerHeight;
      setShowStickyBtn(window.scrollY > heroHeight);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-black">
      {/* 1. Title / Questionnaire Section */}
      <HeroSection />
      
      {/* 2. Real Results (Testimonials with Before/After) */}
      <TestimonialsSection />
      
      {/* 3. How It Works (3-step process) */}
      <HowItWorks />
      
      {/* 4. What You Get (Deliverables) */}
      <WhatYouGet />
      
      {/* 5. Is This Right For You? */}
      <ForYouSection />
      
      {/* 6. Why This Is Different */}
      <WhyDifferent />
      
      {/* 7. FAQ */}
      <FAQSection />
      
      {/* Footer */}
      <Footer />

      {/* Sticky Apply Button - Shows after scrolling past hero */}
      {showStickyBtn && (
        <button
          onClick={scrollToTop}
          className="sticky-apply-btn"
          aria-label="Apply for coaching"
        >
          <ArrowUp className="w-4 h-4" />
          Apply Now
        </button>
      )}
    </div>
  );
};

export default LandingPage;
